import UserPaymentIcon from '@material-ui/icons/AccountBalanceWallet';
import AdjustmentIcon from '@material-ui/icons/Adjust';
import StatIcon from '@material-ui/icons/Assessment';
import BookmakerApprovalIcon from '@material-ui/icons/AssignmentTurnedIn';
import BookmakerIcon from '@material-ui/icons/Bookmarks';
import BonusComparatorIcon from '@material-ui/icons/Compare';
import DashboardIcon from '@material-ui/icons/Dashboard';
import EventIcon from '@material-ui/icons/EmojiEvents';
import BookmakerDealIcon from '@material-ui/icons/EuroSymbol';
import UserIcon from '@material-ui/icons/Face';
import RewardIcon from '@material-ui/icons/FormatListNumbered';
import UserWtrIcon from '@material-ui/icons/Gavel';
import BookmakerImport from '@material-ui/icons/History';
import LanguageMessagesIcon from '@material-ui/icons/Language';
import BookmakerChannelIcon from '@material-ui/icons/Link';
import RoleIcon from '@material-ui/icons/Lock';
import ContestIcon from '@material-ui/icons/Loyalty';
import StatDeclinatedIcon from '@material-ui/icons/MoneyOff';
import NotificationsIcon from '@material-ui/icons/Notifications';
import PagesIcon from '@material-ui/icons/Pages';
import BookmakerBlacklistIcon from '@material-ui/icons/PanTool';
import BookmakerWhitelistIcon from '@material-ui/icons/PlaylistAddCheck';
import DynamicVariableIcon from '@material-ui/icons/Timeline';
import BookmakerLandingIcon from '@material-ui/icons/ViewCarousel';

const UserProfileApprovalIcon = BookmakerApprovalIcon;

export {
  AdjustmentIcon,
  BonusComparatorIcon,
  BookmakerApprovalIcon,
  BookmakerBlacklistIcon,
  BookmakerChannelIcon,
  BookmakerDealIcon,
  BookmakerIcon,
  BookmakerImport,
  BookmakerLandingIcon,
  BookmakerWhitelistIcon,
  ContestIcon,
  DashboardIcon,
  DynamicVariableIcon,
  EventIcon,
  LanguageMessagesIcon,
  NotificationsIcon,
  PagesIcon,
  RewardIcon,
  RoleIcon,
  StatDeclinatedIcon,
  StatIcon,
  UserIcon,
  UserPaymentIcon,
  UserProfileApprovalIcon,
  UserWtrIcon,
};
